import React from "react";
import "./summaryStatsRow.css";

export default function SummaryStatsRow({ stats, isSold = false }) {
  const { activeListings, soldListings, avgPrice, avgMileage, avgSoldDom } = stats;
  const listings = isSold ? soldListings : activeListings;
  const listingsLabel = isSold ? "Sold Listings" : "Active Listings";

  return (
    <div className={`summary-stats-row ${isSold ? "summary-stats-row-4" : ""}`}>
      <div className="ssr-card">
        <div className="ssr-content">
          <div className="ssr-label">{listingsLabel}</div>
          <div className="ssr-value">{listings}</div>
        </div>
      </div>

      <div className="ssr-card ssr-card-hero">
        <div className="ssr-content">
          <div className="ssr-label">Average Price</div>
          <div className="ssr-value">${avgPrice.toLocaleString()}</div>
        </div>
      </div>

      <div className="ssr-card">
        <div className="ssr-content">
          <div className="ssr-label">Average Mileage</div>
          <div className="ssr-value">{avgMileage.toLocaleString()} mi</div>
        </div>
      </div>

      {isSold && avgSoldDom !== undefined && (
        <div className={`ssr-card ${avgSoldDom < 45 ? 'ssr-card-green' : avgSoldDom <= 90 ? 'ssr-card-yellow' : 'ssr-card-red'}`}>
          <div className="ssr-content">
            <div className="ssr-label">Sold DOM</div>
            <div className={`ssr-value ${avgSoldDom < 45 ? 'ssr-value-green' : avgSoldDom <= 90 ? 'ssr-value-yellow' : 'ssr-value-red'}`}>{avgSoldDom} days</div>
          </div>
        </div>
      )}
    </div>
  );
}

